import React from "react";
import { useQuery } from "@apollo/client";

import { ACTUAL_AUTH } from "../../stores/db/auth";
import { Track, TRACKS } from "../../stores/queries/tracks";
import { Button, Table } from "../../ui";
import { LOG, T, theme } from "../../config";
import { useHistory } from "react-router";

const WarnBtn = ({ track }: { track: Track }) => {
  const history = useHistory();
  let color: any = "white";
  if (track.warnings && track.warnings.length > 0) {
    color = "yellow";
    for (let index = 0; index < track.warnings.length; index++) {
      if (track.warnings[index].ifClosed) {
        color = "red";
      }
    }
  }
  return (
    <Button
      style={{ width: "85%", fontSize: 14 }}
      color={color}
      onClick={() => {
        history.push("/admin/area/tracks/" + track.id + "/warnings");
      }}
    >
      {track.warnings && track.warnings.length > 0
        ? track.warnings.length
        : "+"}
    </Button>
  );
};

const columns: any = [
  {
    name: T("name"),
    selector: "name",
    sortable: true,
    minWidth: "20%",
    style: { fontWeight: 600 },
  },
  {
    name: T("number"),
    selector: "detailedInfo.trackNumber",
    sortable: true,
    //center: true,
    hide: "md",
  },
  {
    name: T("category"),
    selector: "category",
    sortable: true,
    cell: (row: Track) => T(row.category),
    //center: true,
    hide: "md",
  },
  {
    name: T("typology"),
    selector: "typology",
    sortable: true,
    cell: (row: Track) => T(row.typology),
    //center: true,
    hide: "md",
  },
  {
    hide: "md",
    name: (
      <div className="flex h-full w-full flex-col items-center justify-center">
        <h1>STATO</h1>
        <h4 style={{ fontSize: "80%" }}>Sorgente</h4>
      </div>
    ),
    cell: (row: Track) => (
      <div style={{ fontSize: 9, fontWeight: "bold" }}>
        {typeof row?.statusFromExternalSource === "boolean" ? (
          <>
            <i
              className="fa fa-circle"
              style={{
                color: row?.statusFromExternalSource
                  ? theme.vars.colors.greenLight
                  : theme.vars.colors.redLight,
                opacity: 0.5,
              }}
            />{" "}
            A
          </>
        ) : (
          <>
            {typeof row?.originalStatus === "boolean" ? (
              <>
                <i
                  className="fa fa-circle"
                  style={{
                    color: row?.originalStatus
                      ? theme.vars.colors.greenLight
                      : theme.vars.colors.redLight,
                    opacity: 0.5,
                  }}
                />{" "}
                M
              </>
            ) : (
              <i
                className="fa fa-minus"
                style={{
                  color: theme.vars.colors.greyLight,
                }}
              />
            )}
          </>
        )}
      </div>
    ),
    width: "60px",
    sortable: false,
    center: true,
    style: { borderLeft: "1px solid #eee" },
  },
  {
    name: (
      <div className="flex h-full w-full flex-col items-center justify-center">
        <h1>STATO</h1>
        <h4 style={{ fontSize: "80%" }}>Attuale</h4>
      </div>
    ),
    cell: (row: Track) => (
      <div>
        {typeof row?.status === "boolean" ? (
          <i
            className="fa fa-circle"
            style={{
              color: row?.status
                ? theme.vars.colors.greenLight
                : theme.vars.colors.redLight,
            }}
          />
        ) : (
          <i
            className="fa fa-minus"
            style={{
              color: theme.vars.colors.greyLight,
            }}
          />
        )}
      </div>
    ),
    width: "60px",
    sortable: false,
    center: true,
    style: { borderLeft: "1px solid #eee" },
  },
  {
    name: "AVVISI",
    cell: (row: Track) => <WarnBtn track={row} />,
    width: "110px",
    sortable: false,
    center: true,
    hide: "md",
    style: { borderLeft: "1px solid #eee" },
  },
];

const TracksList = () => {
  const history = useHistory();
  const { error, data } = useQuery<{
    userTracks: Track[];
  }>(TRACKS, {
    variables: {
      area: ACTUAL_AUTH.area,
    },
    fetchPolicy: "cache-and-network",
  });

  if (error) {
    LOG.error(error);
  }

  return (
    <>
      <div
        className={
          "relative flex flex-1 flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-2xl bg-white"
        }
      >
        <Table
          columns={columns}
          defaultSortField={"category"}
          data={data?.userTracks || []}
          height={"calc(100vh - 240px)"}
          title={"Lista Tracciati"}
          loading={data ? false : true}
          filterSelector={"name"}
          onRowClick={(row: Track, event) => {
            history.push("/admin/area/tracks/" + row.id);
          }}
        />
      </div>
    </>
  );
};

export { TracksList };
